import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';

const styles = {
  wrapper: {
    padding: 15
  },
};

class ScoreByHourOfDayBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const scoreByHourOfDay = answersReport ? answersReport.scoreByHourOfDay : [];

    const categories = scoreByHourOfDay.map(item => item.hour);
    const data = scoreByHourOfDay.map(item => item.score);

    const chartConfig = {
      chart: {
        type: 'column',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
        marginLeft: 20,
        marginRight: 20,
      },
      title: {
        text: intl.formatMessage({id: 'score'}),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: scoreByHourOfDay[index].count,
          });
        },
      },
      xAxis: {
        categories,
        title: {
          text: intl.formatMessage({id: 'hourOfDay'}),
        },
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: '{y:.1f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(ScoreByHourOfDayBarChart),
  graphql`
    fragment ScoreByHourOfDayBarChart_answersReport on AnswersReport {
      scoreByHourOfDay {
        hour
        score
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/ScoreByHourOfDayBarChart/ScoreByHourOfDayBarChart.js